/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */
import { userStorePinLabel } from "../../theme";

import { EmailNotificationsToggle, ChangePasswordSection } from "./NotificationSettings";

export function SettingsPage({ user, lang, setLang }) {
  const isStoreManager = user.role === "store_manager";

  return (
    <div style={{ maxWidth: 480, display: "flex", flexDirection: "column", gap: 16 }}>
      <section
        style={{
          background: "var(--surface)",
          border: "1px solid var(--border)",
          borderRadius: 18,
          padding: "18px 18px 16px",
        }}
      >
        <div
          style={{
            fontFamily: "Bebas Neue, sans-serif",
            fontSize: 22,
            color: "var(--text-primary)",
            letterSpacing: 0.5,
            lineHeight: 1,
          }}
        >
          {lang === "gr" ? "Προσωπικά" : "Personal"}
        </div>

        <div style={{ marginTop: 16 }}>
          <div className="form-label" style={{ marginBottom: 8 }}>
            {lang === "gr" ? "Γλώσσα" : "Language"}
          </div>
          <div className="lang-switcher" style={{ display: "inline-flex" }}>
            <button
              type="button"
              className={`lang-option ${lang === "en" ? "lang-active" : ""}`}
              onClick={() => setLang("en")}
            >
              EN
            </button>
            <button
              type="button"
              className={`lang-option ${lang === "gr" ? "lang-active" : ""}`}
              onClick={() => setLang("gr")}
            >
              ΕΛ
            </button>
          </div>
        </div>

        <EmailNotificationsToggle lang={lang} user={user} />
        <ChangePasswordSection lang={lang} />
      </section>

      {isStoreManager && (
        <section
          style={{
            background: "var(--surface)",
            border: "1px solid var(--border)",
            borderRadius: 18,
            padding: "18px 18px 16px",
          }}
        >
          <div
            style={{
              fontFamily: "Bebas Neue, sans-serif",
              fontSize: 22,
              color: "var(--text-primary)",
              letterSpacing: 0.5,
              lineHeight: 1,
            }}
          >
            {lang === "gr" ? "Κατάστημα" : "Store"}
          </div>
          <div style={{ marginTop: 14 }}>
            <div className="form-label" style={{ marginBottom: 6 }}>
              {lang === "gr" ? "Όνομα καταστήματος" : "Store name"}
            </div>
            <div className="user-store" style={{ marginTop: 0 }}>
              📍 {userStorePinLabel(user)}
            </div>
          </div>
        </section>
      )}
    </div>
  );
}

